exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pretty.p-toggle .state.p-success label:after,.pretty input:checked~.state.p-success label:after{background-color:var(--secondary-color)!important}", ""]);

// exports
